export const partnerGroupChannelQueryKeys = {
  all: ['partner-group-channel'],
  detail: (memberLimit = 50) => [...partnerGroupChannelQueryKeys.all, 'detail', { memberLimit }],
  messages: (limit = 20, channelId = null, resolvedAt = null) => [
    ...partnerGroupChannelQueryKeys.all,
    'messages',
    {
      limit,
      channelId: channelId || null,
      resolvedAt: resolvedAt || null,
    },
  ],
  joinRequests: () => [...partnerGroupChannelQueryKeys.all, 'join-requests'],
};
